import { render, staticRenderFns } from "./AddSendwayDialog.vue?vue&type=template&id=2848580e&scoped=true"
import script from "./AddSendwayDialog.vue?vue&type=script&lang=js"
export * from "./AddSendwayDialog.vue?vue&type=script&lang=js"
import style0 from "./AddSendwayDialog.vue?vue&type=style&index=0&id=2848580e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2848580e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2848580e')) {
      api.createRecord('2848580e', component.options)
    } else {
      api.reload('2848580e', component.options)
    }
    module.hot.accept("./AddSendwayDialog.vue?vue&type=template&id=2848580e&scoped=true", function () {
      api.rerender('2848580e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/AddSendwayDialog.vue"
export default component.exports